/**
 * Credit Card Key state.
 */
import { make } from "vuex-pathify";
import api from "@/api";
import emptyCard from "@/pages/Organization/creditcard";
import _ from "lodash";

const endPoint = api.props.endPoints.creditCard;

const state = {
  card: emptyCard,
  ogCard: emptyCard,
  errorsOccurred: false
};

// automatically generate getters
const getters = make.getters(state);

const mutations = {
  ...make.mutations(state),
  // override
  setCard(state, card) {
    if (card.length >= 1) {
      state.card = card[0];
      state.ogCard = this.copy("card/card");
    } else {
      state.card = emptyCard;
      state.ogCard = this.copy("card/card");
    }
  },
  setErrorsOccurred(state, value) {
    state.errorsOccurred = value;
  },
  cleanCard(state) {
    state.ogCard = _.cloneDeep(state.card);
  },
  rollbackCard(state) {
    state.card = _.cloneDeep(state.ogCard);
  }
};

const actions = {
  ...make.actions(state),

  loadCard({ commit }) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .getEntity(endPoint)
        .then(card => {
          if (card.length >= 1) {
            commit("setCard", card);
          } else {
            commit("setCard", emptyCard);
          }
          resolve();
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit(
            "pushError",
            ex.msg || ex.value || "Failed to load API Card.",
            {
              root: true
            }
          );
        });
    });
  },
  updateCard({ commit }, dirtyCard) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve, reject) {
      api
        .setEntity(endPoint, dirtyCard)
        .then(() => {
          commit("cleanCard", dirtyCard);
          resolve();
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit("rollbackCard");
          commit(
            "pushError",
            ex.msg || `Failed to update Card "${dirtyCard.card.maskedNumber}".`,
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  deleteCard({ commit }) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .delete(endPoint, state.card.id)
        .then(() => {
          resolve();
        })
        .catch(function(ex) {
          commit("setErrorsOccurred", true);
          commit(
            "pushError",
            ex.msg || ex.value || "Failed to delete API Card.",
            {
              root: true
            }
          );
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
